import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TBr } from './models';

export const Br: FC<TBr> = ({ inline = false, styles }) => {
    const classNames =
        cn({
            [styles.block]: !inline,
        }) || undefined;

    return <span className={classNames}>{inline && ' '}</span>;
};
